import { LitElement, html, css, nothing } from 'lit'

export class SideDrawerBtn extends LitElement {
  static styles = css`
    button {
      cursor: pointer;
      background: none;
      border: none;
      padding: 0;
      display: flex;
      align-items: center;
    }

    .flex-1 {
      flex: 1 1 0%;
    }

    .justify-start {
      justify-content: flex-start;
    }

    .justify-end {
      justify-content: flex-end;
    }
  `

  static properties = {
    for: { type: String, reflect: true },
    active: { type: Boolean, reflect: true },
    stretch: { type: String },
    label: { type: String },
  }

  constructor() {
    super()
    this.active = false
    this._toggle = () => {
      this.active = !this.active
    }
  }

  connectedCallback() {
    super.connectedCallback()
    if (!this.label) {
      this.label = this.getAttribute('aria-label') || ''
    }
    this.class = ''
    if (this.stretch === 'right') {
      this.class = 'flex-1 justify-end'
    } else if (this.stretch === 'left') {
      this.class = 'flex-1 justify-start'
    }
    window.MicroBus.on(`${this.for}:toggle`, this._toggle)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.MicroBus.on(`${this.for}:toggle`, this._toggle)
  }

  render() {
    return html`
      <button class="${this.class}" @click=${this._onClick} aria-label="${this.label || nothing}" aria-haspopup="dialog">
        <slot></slot>
      </button>
    `
  }

  _onClick() {
    window.MicroBus.emit(`${this.for}:toggle`)

    if (this.for === 'mobile-menu' && this.active) {
      if (window.gtag) {
        window.gtag('event', 'Mobile Navigation Open')
      }
    } else if (this.for === 'search-side-drawer') {
      if (window.gtag) {
        window.gtag('event', 'Navigation Search Click')
      }
    }
  }
}

customElements.define('side-drawer-btn', SideDrawerBtn)
